import { useCallback, useMemo, type Dispatch, type SetStateAction } from 'react';
import { useStoredValue, type StorageKey } from 'app/lib/storage';

type Selection = string[] | undefined;

/** Restores catalog preferences without overwriting a live route or picker selection. */
export function useStoredCatalogSelection(
  key: StorageKey,
  [selection, setSelection]: [Selection, Dispatch<SetStateAction<Selection>>],
  defaultId?: string,
) {
  const defaultSelection = useMemo(() => (defaultId ? [defaultId] : []), [defaultId]);
  const hydrateSelection = useCallback(
    (stored: SetStateAction<Selection>) => {
      setSelection((current) => current ?? (typeof stored === 'function' ? stored(current) : stored));
    },
    [setSelection],
  );
  const [value, , , loaded] = useStoredValue<string[]>(key, defaultSelection, [selection, hydrateSelection]);
  return { value, loaded };
}
